import {
  CheckCircle,
  Rocket,
  Target,
  Users,
} from "lucide-react";
import workingBg from "../../assets/images/Panda/red-panda-mascot-ready-to-action.png";
import ResponsiveImage from "../common/ResponsiveImage";

const reasons = [
  {
    title: "Đội ngũ chuyên môn cao",
    description:
      "Kết hợp tư duy thiết kế, kỹ thuật triển khai và góc nhìn kinh doanh để đưa ra giải pháp phù hợp thực tế.",
    icon: Users,
  },
  {
    title: "Hướng đến kết quả",
    description:
      "Mỗi đề xuất đều gắn với mục tiêu rõ ràng như tăng chuyển đổi, củng cố thương hiệu hoặc tối ưu vận hành.",
    icon: Target,
  },
  {
    title: "Trách nhiệm",
    description:
      "Làm việc minh bạch, bám sát tiến độ và chủ động xử lý vấn đề để khách hàng yên tâm trong suốt quá trình triển khai.",
    icon: CheckCircle,
  },
  {
    title: "Sáng tạo",
    description:
      "Không rập khuôn theo mẫu có sẵn, chúng tôi chọn cách tiếp cận phù hợp với từng ngành và từng bài toán cụ thể.",
    icon: Rocket,
  },
];

const SectionReason: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#fff7f7] to-white py-16 md:py-20">
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.92),rgba(255,243,243,0.98))]" />
      <div className="relative container">
        <div className="mx-auto max-w-[1180px]">
          <div className="grid items-start gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-8">
            <div className="flex flex-col">
              <span className="inline-flex w-fit items-center rounded-full border border-red-500/20 bg-red-50 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-red-700 md:px-4 md:py-2">
                Sự khác biệt
              </span>

              <div className="mt-5 max-w-[700px]">
                <h2 className="text-[24px] font-semibold leading-[1.2] text-[#3f1717] sm:text-[27px] md:text-[30px] lg:text-[33px]">
                  Lý do doanh nghiệp chọn <span className="whitespace-nowrap">TrioCore Solutions</span>
                </h2>
                <p className="mt-4 max-w-[660px] text-[14px] leading-7 text-gray-600 md:text-[15px] md:leading-8">
                  Chúng tôi ưu tiên hiệu quả sử dụng, tiến độ rõ ràng và khả năng đồng hành dài
                  hạn để hệ thống sau khi bàn giao thực sự tạo ra giá trị thay vì chỉ dừng ở phần
                  nhìn.
                </p>
              </div>

              <div className="mt-6 grid gap-3 sm:grid-cols-2 md:gap-4">
                {reasons.map(({ title, description, icon: Icon }) => (
                  <article
                    key={title}
                    className="rounded-[20px] border border-red-100 bg-white/92 p-4 shadow-[0_10px_24px_rgba(127,29,29,0.06)] md:p-[18px]"
                  >
                    <div className="mb-3 flex items-center gap-3">
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[linear-gradient(135deg,#ef4444_0%,#b91c1c_100%)] text-white shadow-[0_8px_16px_rgba(220,38,38,0.14)]">
                        <Icon size={17}  />
                      </div>
                      <h3 className="text-[16px] font-semibold leading-tight text-[#2f1a1a] md:text-[17px]">
                        {title}
                      </h3>
                    </div>
                    <p className="text-[12.5px] leading-[22px] text-gray-600 md:text-[13px]">
                      {description}
                    </p>
                  </article>
                ))}
              </div>
            </div>

            <div className="relative order-first flex min-h-[250px] items-end rounded-[24px] border border-red-100 bg-white/82 px-4 pt-5 shadow-[0_16px_38px_rgba(127,29,29,0.07)] sm:px-5 md:min-h-[320px] md:px-6 md:pt-8 lg:order-none lg:min-h-[100%]">
              <div className="absolute inset-x-10 bottom-4 h-6 rounded-full bg-red-950/8 blur-2xl" />
              <ResponsiveImage
                src={workingBg}
                alt="TrioCore Solutions mascot"
                className="relative z-10 mx-auto h-auto w-full max-w-[220px] object-contain sm:max-w-[250px] md:max-w-[300px] lg:max-w-[360px] xl:max-w-[380px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionReason;
